import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { HomePage } from './pages/HomePage';
import { ImmersiveModule } from './pages/ImmersiveModule';
import { RhythmGameModule } from './pages/RhythmGameModule';
import { EmotionPaletteModule } from './pages/EmotionPaletteModule';
import { RolePlayModule } from './pages/RolePlayModule';
import { InstrumentModule } from './pages/InstrumentModule';
import { PoemCourseModule } from './pages/PoemCourseModule';
import { MelodyModule } from './pages/MelodyModule';
export type PageType = 'home' | 'immersive' | 'rhythm' | 'emotion' | 'roleplay' | 'instrument' | 'course' | 'melody';
export interface PageParams {
  id?: string;
  type?: string;
}
export function App() {
  const [currentPage, setCurrentPage] = useState<PageType>('home');
  const [pageParams, setPageParams] = useState<PageParams>({});
  const handleNavigate = (page: PageType, params: PageParams = {}) => {
    setCurrentPage(page);
    setPageParams(params);
  };
  const renderPage = () => {
    switch (currentPage) {
      case 'immersive':
        return <ImmersiveModule onBack={() => handleNavigate('home')} data-id="element-0" />;
      case 'rhythm':
        return <RhythmGameModule onBack={() => handleNavigate('home')} data-id="element-1" />;
      case 'emotion':
        return <EmotionPaletteModule onBack={() => handleNavigate('home')} data-id="element-2" />;
      case 'melody':
        return <MelodyModule onBack={() => handleNavigate('home')} data-id="element-3" />;
      case 'roleplay':
        return <RolePlayModule onBack={() => handleNavigate('home')} data-id="element-4" />;
      case 'instrument':
        return <InstrumentModule onBack={() => handleNavigate('home')} instrumentId={pageParams.id} data-id="element-5" />;
      case 'course':
        return <PoemCourseModule onBack={() => handleNavigate('home')} courseId={pageParams.id} data-id="element-6" />;
      default:
        return <HomePage onNavigate={handleNavigate} data-id="element-7" />;
    }
  };
  return <div className="antialiased text-slate-900 bg-white min-h-screen font-body" data-id="element-8">
      <AnimatePresence mode="wait" data-id="element-9">
        <div key={currentPage} className="w-full h-full" data-id="element-10">
          {renderPage()}
        </div>
      </AnimatePresence>
    </div>;
}